<template>
    <van-popup
        v-model="popupPay"
        position="bottom"
        :close-on-click-overlay='false'
    >
        <div class="selectPay">
            <div class="selectPay_content">
                <div class="selectPay_content_title selectPay_borderBottom">
                    <h3>选择支付方式</h3>
                </div>

                <div class="selectPay_content_li selectPay_borderBottom" v-for="(item, index) in payModelList" :key='item.type' @click="onPayment(index)">
                    {{ item.payName }}
                </div>
            </div>
            <div class="selectPay_btn" @click="onHide">
                取消
            </div>
        </div>
    </van-popup>
</template>
<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        payModelList: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    computed: {
        // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
        popupPay: {
            get () {
                return this.visible
            },
            set () {
                this.$emit('update:visible')
            }
        }
    },
    methods: {
        onHide () {
            this.$emit('update:visible')
        },
        onPayment (value) {
            this.$emit('update:visible')
            this.$emit('getPayment', value)
        }
    }
}
</script>
<style lang="scss" scoped>
.selectPay{
    margin: 0 24px;
    text-align: center;
    font-size: 36px;
    color: #000000;
    &_content {
        background: #ffffff;
        border-radius: 8px;
        &_title {
            font-size: 32px;
            color: #666666;
            padding: 32px 0;
            position: relative;
            p{
                font-size: 24px;
                color: #999999;
                margin-top: 8px;
            }
        }
        &_li{
            padding: 32px 0;
            position: relative;
        }
    }
    &_btn{
        background: #ffffff;
        border-radius: 8px;
        padding: 32px 0;
        margin: 12px 0;
        color: #FF7A45;
    }
    &_borderBottom {
        position: relative;
        &::before {
            position: absolute;
            content: '';
            bottom: 0;
            right: 0;
            left: 0;
            width: 100%;
            border-bottom: 2px solid rgba(209,209,214,1);
            transform: scaleY(0.5);
            z-index: 8;
        }
    }
}
/deep/ .van-popup{
    background: none;
}
</style>